<template>
    <div>
        <Navbar/>
        <div id="faq">
            <div class="row pt-5">
                <div class="col text-center">
                    <h1 class="lato-light">FAQ</h1>
                </div>
            </div>
            <div class="row pt-3 pb-5">
                <div class="col-sm-8 col-10 offset-sm-2 offset-1 text-center">
                    <h6 class="lato-bold">WHAT IS THE AFFILIATE PROGRAM?</h6>
                    <p class="lato-light">
                        A flexible and reliable program that rewards partners and affiliates for contributing to <b>Bitcoin.com Games.</b> In simple terms;  you promote our Games and we reward you with a competitive commissions package.  The more you contribute the higher the reward.
                    </p>
                    <p class="lato-light">
                        To get started,  you just need to register in our program and start referring your players, visitors or subscribers to <b>Bitcoin.com Games.</b> We provide all the advertising material you need, from ad banners to ad content.
                    </p>
                    <p class="lato-light">
                        Each affiliate will be provided with a unique tracking link.  You can place the affiliate link on your website, on your banners, embedded in emails, or in any other communications you have with your audience/network. You will be compensated according to the total net revenue generated by your referred accounts.  It’s as simple as that!
                    </p>
                    <p class="lato-light">
                        You will receive a monthly commission based on the revenue contributed by your audience/network. Your monthly commission percentage is calculated as follows:
                    </p>
                    <p class="lato-light text-center">
                        <b> ( % commission tier * Total Month’s Net revenue of affiliate’s network )</b>
                    </p>


                    <h6 class="pt-5 lato-bold">WHY SHOULD I REGISTER ON THE AFFILIATE PROGRAM?</h6>
                    <ul>
                        <li>
                            <p class="lato-light">
                                That’s where the money is! We offer unique commission rates and the very best promotions to attract top affiliates. With our program and our solid brand, you will see the results of your marketing activities in days!
                            </p>
                        </li>
                        <li>
                            <p class="lato-light">
                                We believe in Freedom and want to empower our players and affiliates to have the best possible options in the market. We launched <b>Bitcoin.com Games</b> in 2016 and were one of the very first Bitcoin casinos. Today we have already become one of the biggest, most trusted popular Bitcoin casinos in the industry. Our Games team has more than 20 years’ experience in the gambling and blockchain industry.
                            </p>
                        </li>
                        <li>
                            <p class="lato-light">
                                After trying our Casino, your players won’t look back! We are proud of our product and offer players a top-quality casino experience. We have higher payouts and jackpots than any other online casinos, instant withdrawals, and deposits, the best selection of games. All our exclusive games are provably fair. Players can enjoy total anonymity, new promotions and bonuses, and a lot more.
                            </p>
                        </li>
                        <li>
                            <p class="lato-light">
                                We are here for you. Our affiliates are supported by a dedicated and knowledgeable affiliate team always available to offer personalized service and support. We give you lots of different pre-made marketing tools, assets, and resources designed to help you constantly improve your click-throughs and conversions, and ultimately, maximize your earnings.
                            </p>
                        </li>
                    </ul>

                    <h6 class="pt-5 lato-bold">CAN I REGISTER IN THE AFFILIATE PROGRAM?</h6>
                    <p class="lato-light">
                        If you have an audience, you can register on our affiliate program! Register on our affiliate program and start referring your website visitors, customers or subscribers to <b>Bitcoin.com Games.</b>
                    </p>

                    <h6 class="pt-5 lato-bold">DO YOU CHARGE ANY FEES TO BE ASSOCIATED WITH BITCOIN.COM GAMES AFFILIATES?</h6>
                    <p class="lato-light">
                        Joining <b>Bitcoin.com Games Affiliates</b> is 100% free.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW DO I REGISTER TO BECOME A BITCOIN.COM GAMES AFFILIATE?</h6>
                    <p class="lato-light">
                        Becoming a member of <b>Bitcoin.com Games Affiliates</b> could not be easier. Click on “Register”, fill it out the information in the fields, and we will be in touch as soon as we review your application.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW MANY WEBSITES CAN I REGISTER?</h6>
                    <p class="lato-light">
                        As many as you'd like! When your application is approved, you will be able to register several websites in your account and create different affiliate tracking links for each site. This way you can track their performance and results separately.
                    </p>

                    <h6 class="pt-5 lato-bold">DOES BITCOIN.COM GAMES AFFILIATES ACCEPT ALL WEBSITES?</h6>
                    <p class="lato-light">
                        No, we only accept websites that match our brand values and markets. We review each affiliate website before approving it. We will get in touch with you to let you know you know our decision.
                    </p>

                    <h6 class="pt-5 lato-bold">I DON’T HAVE MY OWN WEBSITE - CAN I BECOME AN AFFILIATE?</h6>
                    <p class="lato-light">
                        Yes, our program is not only open to affiliates with websites. There are lots of ways to promote <b>Bitcoin.com Games</b> and we offer plenty of marketing tools you can use. Contact our affiliate managers today at affiliates@bitcoin.com to discuss the options available to you.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW DO YOU TRACK MY TRAFFIC?</h6>
                    <p class="lato-light">
                        When a player clicks on your affiliate link), a cookie, which is a small text file with your affiliate account’s unique identifier in it, is placed on their computer. Whenever the player that you referred registers as a new player at our casino, our website will see this cookie and assign this player to your affiliate account, and track all of the net revenue they generate, which you will get paid on.
                    </p>
                    <p class="lato-light">
                        These cookies last for 30 days. This means that anyone you refer will need to register at <b>Bitcoin.com Games</b> within 30 days of clicking your affiliate link in order for you to get credit for the referral.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW MUCH CAN I EARN?</h6>
                    <p class="lato-light">
                        The sky's the limit! We don’t impose any limits to the maximum commissions that our affiliates make, so the more revenue you bring, the more you earn, With our large brand recognition, generous commissions and innovative promotions, you will make more money with us than with any other casino.
                    </p>

                    <h6 class="pt-5 lato-bold">CAN I GET COMMISSIONS FROM REFERRING NEW AFFILIATES?</h6>
                    <p class="lato-light">
                        Yes, you can. For every new affiliate that is referred to by you and accepted in the <b>Bitcoin.com Games</b> affiliate program, you will earn a percentage of the net revenues generated by every player your sub-affiliates refer to Bitcoin.com Games.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW DO I GET COMPENSATED?</h6>
                    <p class="lato-light">
                        We calculate commissions at the beginning of each month for the previous month's activity and we pay you your commissions in BTC within the first 2 weeks of each month.
                    </p>
                    <p class="lato-light">
                        Your monthly commission is a percentage of the total net revenue generated by all of the players you and your sub-affiliates have referred to <b>Bitcoin.com Games.</b> To calculate net revenue, we simply look at your player’s total bets and subtract all wins and direct costs associated with those players, such as bonuses, loyalty rewards, payment fees, and chargebacks.
                    </p>

                    <h6 class="pt-5 lato-bold">DO NEGATIVE BALANCES CARRY OVER?</h6>
                    <p class="lato-light">
                        We offer no negative carry-over policy. Your negative balance will be reset to 0 on the 1st of each month.
                    </p>

                    <h6 class="pt-5 lato-bold">HOW CAN I CONTACT YOU?</h6>
                    <p class="lato-light">
                        You can contact us anytime at affiliates@bitcoin.com.
                    </p>
                </div>
            </div>
            <Footer isBackgroundImage="false"/>
        </div>
    </div>
</template>

<script>
    import Navbar from "./Navbar";
    import Footer from "./Footer";
    import { mapActions } from 'vuex';

    export default {
        name: "FAQ",
        components: {
            Navbar,
            Footer
        },
        methods: {
            ...mapActions([
                'setActiveTab',
            ])
        },
        created: function() {
            this.setActiveTab('faq');
        }
    }
</script>

<style scoped>
    #faq {
        background-image: url('~@/assets/faq.png');

        height: 100vh;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 110%;
        margin-top:55px;
    }

    h6 {
        color: #004750;
        font-size: calc(0.5rem + 2vmin);
    }

    p {
        text-align: justify;
        font-size: calc(0.4rem + 2vmin);
    }
</style>